import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useGoogleAuth } from '../contexts/GoogleAuthContext';
import { useIsAdmin } from '../hooks/useIsAdmin';
import vistaLogo from '../assets/vista-logo.svg';

const Navigation: React.FC = () => {
    const location = useLocation();
    const { instance, accounts } = useMsal();
    const { isGoogleAuthenticated, googleUserName, signOutGoogle } = useGoogleAuth();

    const isActive = (path: string) => {
        return location.pathname === path ? 'nav-link active' : 'nav-link';
    };

    const handleLogout = () => {
        if (isGoogleAuthenticated) {
            signOutGoogle();
        } else {
            instance.logoutRedirect();
        }
    };

    const isAdmin = useIsAdmin();

    const userName = isGoogleAuthenticated
        ? googleUserName
        : (accounts[0]?.name ?? accounts[0]?.username ?? 'Gebruiker');

    return (
        <nav className="navigation">
            <div className="nav-container">
                <div className="nav-brand">
                    <img className="nav-logo-mark" src={vistaLogo} alt="GJS IT Solutions & DevOps logo" />
                    <div className="nav-logo-copy">
                        <span className="nav-logo-title">GJS IT Solutions</span>
                        <span className="nav-logo-subtitle">System Reporter</span>
                    </div>
                </div>
                <ul className="nav-menu">
                    <li>
                        <Link to="/" className={isActive('/')}>
                            Devices
                        </Link>
                    </li>
                    <li>
                        <Link to="/map" className={isActive('/map')}>
                            Map
                        </Link>
                    </li>
                    {isAdmin && (
                        <li>
                            <Link to="/tickets" className={isActive('/tickets')}>
                                Tickets
                            </Link>
                        </li>
                    )}
                    <li>
                        <Link to="/uitleg" className={isActive('/uitleg')}>
                            Help
                        </Link>
                    </li>
                </ul>
                <div className="nav-user">
                    <span className="nav-username">{userName}</span>
                    <button className="nav-logout" onClick={handleLogout}>
                        Sign Out
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
